// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dbD2N","histories":"styles_histories__IspbF"};